// Action Types
export const FETCH_TECHLANDSCAPE_REQUEST = "FETCH_TECHLANDSCAPE_REQUEST";
export const FETCH_TECHLANDSCAPE_SUCCESS = "FETCH_TECHLANDSCAPE_SUCCESS";
export const FETCH_TECHLANDSCAPE_FAILURE = "FETCH_TECHLANDSCAPE_FAILURE";

// Action Creators
export const fetchTechlandScapeRequest = (company) => {
return (dispatch) => {
  dispatch({
    type: FETCH_TECHLANDSCAPE_REQUEST,
    payload: company,
  });
};
};
export const fetchTechlandScapeSuccess = (data) => ({
  type: FETCH_TECHLANDSCAPE_SUCCESS,
  payload: data,
});
export const fetchTechlandScapeFailure = (error) => ({
  type: FETCH_TECHLANDSCAPE_FAILURE,
  payload: error,
});
